var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"label-cols":"4","label-align":"right"}},[_c('b-input-group-append',[_c('b-form-datepicker',{attrs:{"value":_vm.value,"state":_vm.valid,"locale":"ru-RU","start-weekday":"1","size":"sm","label-no-date-selected":"Дата не выбрана","no-flip":"","right":""},on:{"input":_vm.input}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }